import React from "react";
import { Link } from "react-router-dom";
import "./DetailLinks.css";

const DetailLinks = () => {
  return (
    <section className="detail-links">
      <div className="detail-container">
        {/* Logo */}
        <div className="detail-logo">
          <Link to="/">
            <img
              src="/img/about.jpeg"
              alt="Home Serves India"
              className="footer-logo"
            />
          </Link>
        </div>

        {/* About */}
        <div className="detail-about">
          <h3>Home Serves India</h3>
          <p>Home Serves India provides expert repair, installation, and maintenance services for RO Water Purifiers, Air Conditioners, Refrigerators, Washing Machines, Microwaves, and other household appliances. Our trained technicians deliver reliable doorstep solutions across multiple cities in India.</p>
        </div>

        {/* Links */}
        <div className="detail-services">
          <h4>Popular Services</h4>
          <Link to="/ro">RO Service</Link>
          {/* <Link to="/ac">AC Service</Link> */}
          <Link to="/washingmachine">Washing Machine Repair</Link>
          <Link to="/refrigerator">Refrigerator Repair</Link>
          <Link to="/microwave">Microwave Repair</Link>
        </div>

      </div>
    </section>
  );
};

export default DetailLinks;